module.exports = __webpack_public_path__ + "img/symbol_9.da66a65e.png";